import { render, staticRenderFns } from "./Ganadores.vue?vue&type=template&id=1253de76&"
import script from "./Ganadores.vue?vue&type=script&lang=js&"
export * from "./Ganadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports